import { Link } from "react-router-dom";
import FilmListRow from "@/components/feature/FilmListRow";
import { FILMS } from "@/mocks/films";

const sortedByDate = [...FILMS].sort((a, b) => b.releaseDate.localeCompare(a.releaseDate)).slice(0, 5);

const HOT_FILMS = [...FILMS].sort((a, b) => b.views - a.views).slice(0, 6);

export default function LatestAndHot() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-8 lg:gap-10">
          <div>
            <div className="flex items-end justify-between gap-3 mb-5">
              <div>
                <p className="text-[11px] tracking-[0.3em] uppercase text-accent-700 mb-1.5">
                  New Releases
                </p>
                <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                  新片速递
                </h2>
              </div>
              <span className="text-[12px] text-foreground-400 whitespace-nowrap">
                按上映日期倒序 · 共 {FILMS.length} 条资料
              </span>
            </div>
            <div className="flex flex-col gap-3">
              {sortedByDate.map((film, index) => (
                <FilmListRow key={film.id} film={film} index={index} />
              ))}
            </div>
            <Link
              to="/category/drama"
              className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-accent-700 transition-colors cursor-pointer"
            >
              查看更多影片资料
              <i className="ri-arrow-right-line text-[13px]" />
            </Link>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between mb-4">
                <h2 className="font-heading text-base font-semibold text-foreground-950 flex items-center gap-2">
                  <i className="ri-trophy-line text-accent-600" />
                  热门推荐
                </h2>
                <span className="text-[11px] text-foreground-400">编辑精选</span>
              </div>
              <ol className="flex flex-col gap-3">
                {HOT_FILMS.map((film, index) => (
                  <li key={film.id}>
                    <Link
                      to={`/detail/${film.id}`}
                      className="group flex items-center gap-3 cursor-pointer"
                    >
                      <span
                        className={`w-6 text-center font-heading text-sm font-semibold shrink-0 ${
                          index < 3 ? "text-accent-600" : "text-foreground-400"
                        }`}
                      >
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div className="w-10 h-[54px] rounded overflow-hidden shrink-0 bg-background-200">
                        <img
                          src={film.cover}
                          alt={`${film.title} 海报`}
                          title={`${film.title} · 热门推荐`}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-[13px] font-medium text-foreground-900 group-hover:text-accent-700 transition-colors line-clamp-1">
                          {film.title}
                        </p>
                        <p className="text-[11px] text-foreground-400 mt-0.5">
                          {film.year} · {film.region} · {(film.views / 1000).toFixed(1)}k 浏览
                        </p>
                      </div>
                      <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-accent-600" />
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg bg-primary-900 p-5 text-background-200">
              <p className="text-[11px] tracking-[0.28em] uppercase text-accent-400 mb-2">
                Site Notice
              </p>
              <h3 className="font-heading text-base font-semibold text-background-50">
                仅提供资料与资讯
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-background-300">
                本站收录影片的剧情简介、演职员与分类信息，不保存、不提供任何影片文件、播放或下载入口。
              </p>
              <Link
                to="/about"
                className="mt-4 inline-flex items-center gap-1.5 text-[13px] text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
              >
                查看免责声明
                <i className="ri-arrow-right-line text-[12px]" />
              </Link>
            </div>

            <div className="rounded-lg border border-background-200 p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3">
                热门演员
              </h3>
              <div className="flex flex-wrap gap-2">
                {["玛戈·德拉克洛瓦", "伊莎贝尔·罗西", "李奥·贝内特", "卡罗琳·薇拉", "娜塔莉·索恩"].map(
                  (name) => (
                    <Link
                      key={name}
                      to={`/search?q=${encodeURIComponent(name)}`}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-[12px] hover:bg-secondary-200 transition-colors cursor-pointer"
                    >
                      {name}
                    </Link>
                  ),
                )}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}